import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getSkuAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/sku', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getSkuAllHeader = (onSuccess, onError) => {
    const response = axios.get('v1/admin/sku/header');
    return handleResponse(response, onSuccess, onError);
};

export const copySku = (payload, onSuccess, onError) => {
    const response = axios.post('v1/admin/sku/header/duplicate', payload);
    return handleResponse(response, onSuccess, onError);
};

export const createSku = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/subcategory/${payload.id_sub_category}/prefix`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateSku = (payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/subcategory/${payload.id_sub_category}/prefix/${payload.prefix}`, { sku_headers: payload.sku_headers });
    return handleResponse(response, onSuccess, onError);
};

export const deleteSku = (id_sub_category, prefix, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/subcategory/${id_sub_category}/prefix/${prefix}`);
    return handleResponse(response, onSuccess, onError);
};

export const getSubcategoryPrefixs = (id_sub_category, onSuccess, onError) => {
    const response = axios.get(`v1/admin/subcategory/${id_sub_category}/prefixs`);
    return handleResponse(response, onSuccess, onError);
};

export const getSubcategoryPrefix = (id_sub_category, prefix, onSuccess, onError) => {
    const response = axios.get(`v1/admin/subcategory/${id_sub_category}/prefix/${prefix}`);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteSku = (id_sub_category, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/subcategory/${id_sub_category}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};